export const HEADER_HEIGHT = 40
export const ROW_HEIGHT = 40
export const OVERSCAN_COUNT = 5

export const DEFAULT_MIN_COLUMN_WIDTH = 20
export const DEFAULT_MAX_COLUMN_WIDTH = 600
